import { SubmitHandler, useForm } from "react-hook-form";

import { Button } from "@design-system/Button/Button";
import { FieldGroup } from "@design-system/FieldGroup/FieldGroup";
import { Form } from "@design-system/Form/Form";
import { TextField } from "@design-system/TextField/TextField";

export type UserFormValues = {
  name: string;
  email: string;
};

type Props = {
  submitText?: string;
  onSubmit: SubmitHandler<UserFormValues>;
  values?: UserFormValues;
  disableEmail?: boolean;
};

export const UserForm = ({
  submitText = "Submit",
  onSubmit,
  values,
  disableEmail = false,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<UserFormValues>({
    values: {
      name: values?.name ?? "",
      email: values?.email ?? "",
    },
  });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FieldGroup label="Name" error={errors.name?.message} required>
        <TextField
          type="text"
          {...register("name", {
            required: { value: true, message: "This field is required" },
          })}
        />
      </FieldGroup>

      <FieldGroup
        label="Email"
        error={errors.email?.message}
        required={!disableEmail}
      >
        <TextField
          type="email"
          {...register("email", {
            required: !disableEmail
              ? { value: true, message: "This field is required" }
              : false,
          })}
          disabled={disableEmail}
        />
      </FieldGroup>

      <Button isLoading={isSubmitting} type="submit">
        {submitText}
      </Button>
    </Form>
  );
};
